import {Component, ElementRef, inject, OnInit, ViewChild} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {BreadcrumbComponent} from '../../shared/breadcrumb/breadcrumb.component';
import {SidebarComponent} from '../../shared/sidebar/sidebar.component';
import {TableModule} from 'primeng/table';
import {CommonModule} from '@angular/common';
import {AvatarModule} from 'primeng/avatar';
import {UserInfoService} from '../../core/services/UserInfo/user-info.service';
import {CommunicationService} from '../../shared/communication-service/communication.service';
import {TieredMenu} from 'primeng/tieredmenu';
import {MenuItem} from 'primeng/api';
import {KeycloakService} from 'keycloak-angular';
import {InputText} from 'primeng/inputtext';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {debounceTime} from 'rxjs';
import {GlobalSearchService} from '../../core/services/global-search.service';
import {GlobalSearchResult, GlobalSearchResultType} from '../../shared/models/commons';
import {Listbox} from 'primeng/listbox';
import {Chip} from 'primeng/chip';
import {Badge, BadgeModule} from 'primeng/badge';
import {Tag} from 'primeng/tag';
import {Panel} from 'primeng/panel';
import {AutoComplete} from 'primeng/autocomplete';
import {TabsModule} from 'primeng/tabs';
import {TabViewModule} from 'primeng/tabview';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, BreadcrumbComponent, SidebarComponent, TableModule, CommonModule, AvatarModule, TieredMenu, InputText, FormsModule, ReactiveFormsModule, Listbox, Chip, Badge, Tag, Panel, AutoComplete, TabsModule, TabViewModule, BadgeModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit {
  private searchService: GlobalSearchService = inject(GlobalSearchService)
  private router: Router = inject(Router);

  constructor(private elementRef: ElementRef, private service: UserInfoService, private _communicationService: CommunicationService, private _keycloakService: KeycloakService) {
  }

  userDetail: any
  sidebarVisible: boolean = true;
  items: MenuItem[] = [];
  private keycloakService = inject(KeycloakService);

  @ViewChild('searchResultsContainer', {static: false}) searchResultsContainer!: ElementRef;
  @ViewChild('globalSearchInput', {static: true}) globalSearchInput!: ElementRef;
  private clickOutsideListener!: (event: MouseEvent) => void;
  private keyListener!: (event: KeyboardEvent) => void;
  globalSearchControl = new FormControl('');
  searchResults!: GlobalSearchResult[] | undefined;
  selectedResult!: GlobalSearchResult;

  ngOnInit() {
    this._keycloakService.getToken().then(token => {
      this.service.getUserProfile(token).subscribe((item) => {
        this.userDetail = item
      })
    });

    this.initializeListeners();
    this.globalSearchControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe(value => {
        this.searchService.search(value ?? '').subscribe({
          next: (result) => {
            this.searchResults = result;
          },
          error: (error) => {
            console.error(error)
          },
          complete: () => {

          }
        })
      })

    this._communicationService.toggleState$.subscribe((item) => {
      this.sidebarVisible = item
    })

    this.items = [
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => this.logout(),
      },
    ];
  }

  logout() {
    console.warn("Logging Out...");
    this.keycloakService.logout();
  }


  onKeyDown($event: KeyboardEvent) {
    if ($event.key === 'Escape') {
      this.searchResults = undefined;
    }
  }

  closeList() {
    this.searchResults = undefined;
  }

  preventClose(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  selectResult(result: GlobalSearchResult) {
    switch (result.type) {
      case "MONITOR":
        this.router.navigate([`projects/${result.projectId}/monitors/${result.id}`]).then(res => {
          this.closeList()
        })
        break;
      case "PROJECT":
        this.router.navigate([`projects/${result.id}/overview`]).then(res => {
          this.closeList()
        }).catch(err => {
          console.error(err)
        })
    }
  }

  get monitors() {
    return this.searchResults?.filter(r => r.type === 'MONITOR');
  }

  get projects() {
    return this.searchResults?.filter(r => r.type === 'PROJECT');
  }


  getEntityTypeLabel(type: GlobalSearchResultType) {
    switch (type) {
      case "MONITOR":
        return "in Monitors";
      case "PROJECT":
        return "in Projects";
      default:
        return "";
    }
  }

  isMac() {
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    return isMac
  }

  private initializeListeners() {
    this.clickOutsideListener = (event) => {
      const isClickInsideInput = this.globalSearchInput.nativeElement.contains(event.target);
      const isClickInsideResults = this.searchResultsContainer?.nativeElement.contains(event.target);
      // if (!this.searchResultsContainer.nativeElement.contains(event.target)) {
      //   this.closeList();
      // }
      if (!isClickInsideInput && !isClickInsideResults) {
        this.closeList();
      }
    };
    this.keyListener = (event) => {

      if (event.ctrlKey && event.code === 'Space') {
        this.globalSearchInput.nativeElement.focus();
        event.preventDefault();
        event.stopPropagation();
      }
    }
    document.addEventListener('keydown', this.keyListener);
    document.addEventListener('click', this.clickOutsideListener);
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.keyListener);
    document.removeEventListener('click', this.clickOutsideListener);
  }

  onFocus() {
    const value = this.globalSearchControl.value;
    this.searchService.search(value ?? '').subscribe({
      next: (result) => {
        this.searchResults = result;
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  logoClickEvent() {
    this.router.navigate([`/dashboard`]);
  }
}
